import { zodResolver } from '@hookform/resolvers/zod';
import { createFileRoute, useRouter } from '@tanstack/react-router';
import { Button } from 'components/Button';
import { Code } from 'components/Code';
import { FormProvider, useForm } from 'react-hook-form';
import { useState } from 'react';

import { VariantSchema, type Variant } from 'shared/modelTypes/variant';

import { VariantForm } from 'forms/VariantForm';
import { emitMessage } from 'engine/api';
import { toast } from 'sonner';
import { X } from 'lucide-react';

export const Route = createFileRoute('/dashboard/variants/new')({
	component: RouteComponent,
	loader: () => emitMessage({ kind: 'game-list' }),
});

function RouteComponent() {
	const data = Route.useLoaderData();

	const gameCount = data.games?.length ?? 0;

	return (
		<div>
			{gameCount <= 0 && <span>Create a game first.</span>}
			{gameCount > 0 && <VariantNewForm gameOptions={data.games?.map((g) => ({ value: g.id, label: g.game.name })) ?? []} />}
		</div>
	);
}

function VariantNewForm(props: { gameOptions: { value: string; label: string }[] }) {
	const router = useRouter();

	const methods = useForm<Variant>({
		// @ts-expect-error zodResolver type inference seems to be bad
		resolver: zodResolver(VariantSchema),
		defaultValues: VariantSchema.parse({ gameId: props.gameOptions[0].value }),
	});

	const err = methods.formState.errors;

	const [result, setResult] = useState<Variant | undefined>();
	const [_res, setRes] = useState<Promise<unknown> | undefined>();

	const onSubmit = async (data: Variant) => {
		setResult(data);
		console.log(data);

		const r = emitMessage({ kind: 'variant-create', variant: data });
		setRes(r);
		const response = await r;
		if (response.success) {
			router.invalidate();
			router.navigate({ to: '/dashboard/variants' });
		} else {
			setRes(undefined);
			toast('server did not save variant', { icon: <X /> });
		}
	};

	console.log(err);

	return (
		<FormProvider {...methods}>
			<form
				className="flex flex-col gap-3"
				// @ts-expect-error zodResolver type inference seems to be bad
				onSubmit={methods.handleSubmit(onSubmit)}
			>
				<VariantForm gameOptions={props.gameOptions} label="New Variant" skinOptions={[]} />
				<Button type="submit">Save variant</Button>
			</form>
			{result && (
				<Code block className="mt-4">
					{JSON.stringify(result, null, 2)}
				</Code>
			)}
		</FormProvider>
	);
}
